import { render, staticRenderFns } from "./FormGeneratorPage.vue?vue&type=template&id=5b7f7970"
import script from "./FormGeneratorPage.vue?vue&type=script&lang=js"
export * from "./FormGeneratorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports